<template>
  <div class="target_desc">
    <div v-if="titleText" class="text_title">{{ titleText }}</div>
    <div class="cont">
      <div class="explain">指标解释</div>
      <div class="cont-c" v-html="innerhtml"></div>
    </div>
  </div>
</template>

<script setup>
  import { ref, toRefs, watch } from 'vue';
  import { useStore } from 'vuex';
  import { getTargetDesc } from '../services/service';

  const store = useStore();
  const props = defineProps({ titleText: { type: String, default: '' } });
  let innerhtml = ref('');
  const { titleText } = toRefs(props);

  const loadTargetDesc = () => {
    getTargetDesc({ id: store.state.targetId.split('-')[0] }).then((rs) => {
      innerhtml.value = rs;
    });
  };

  watch(
    () => store.state.targetId,
    (nv) => {
      loadTargetDesc();
    }
  );
</script>

<style lang="less" scoped>
  .target_desc {
    padding: 0 35px;
    background-color: #fff;
  }
  .text_title {
    padding: 22px 0;
    font-size: 18px;
    color: #000;
    font-weight: 600;
    text-align: center;
  }
  .cont {
    padding: 22px 20px;
    background-color: #ebf1fe;

    .explain {
      padding-bottom: 10px;
      font-size: 14px;
      color: #333;
      font-weight: 600;
    }

    .cont-c {
      color: #666;
    }
  }
</style>